import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CampaignsService {

    private url = GlobalVariables.appURL;

    constructor(private _httpClient: HttpClient) { }

    public list(data: any, type: any, store_orgId?: string): Observable<any> {
        if (type == 'store')
            return this._httpClient.post(this.url + 'campaigns/published-list-for-store'+ (store_orgId ? `?userId=${store_orgId}` : ''), data);
        else
            return this._httpClient.post(this.url + 'campaigns/published-list' + (store_orgId ? `?organizationId=${store_orgId}` : ''), data);
    }

    public detail(id: any): Observable<any> {
        return this._httpClient.get(this.url + 'campaigns/' + id);
    }

    public qrCode(id: any): Observable<any> {
        return this._httpClient.get(this.url + `campaigns/${id}/qrcode`);
    }

    public couponGenerate(id: any): Observable<any> {
        return this._httpClient.post(this.url + 'coupons/generate/' + id, {});
    }

    public guestCouponGenerate(id: any): Observable<any> {
        return this._httpClient.post(this.url + 'guest-coupons/generate/' + id, {});
    }

    // public couponUsage(filter: { limit: number, sort?: { [key: string]: 1 | -1 }, skip: number, where: { endDate?: { '$gte'?: string, '$lte'?: string }, offerType?: string, couponType?: string } } = { limit: 10, skip: 0, where: {} }): Observable<any> {
    //     return this._httpClient.get(this.url + 'coupon-usage/', {
    //         params: new HttpParams().set('filter', JSON.stringify(filter))
    //     });
    // }

    public couponUsagelist(data: any): Observable<any> {
        return this._httpClient.post(this.url + 'coupon-usage/list/', data);
      }

    public storeList(id: any, coordinates: { lat: number, long: number, ownerId?: string }): Observable<any> {
        return this._httpClient.post(this.url + `campaigns/${id}/stores`, coordinates);
    }

    public business_logo(campaignId: any): Observable<any> {
        return this._httpClient.get(this.url + 'campaigns/businesslogo/' + campaignId);
    }

    public profile(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'users/profile/' + id);
  }
}

